import {attributeKeyToId, stringToAttributeId} from './components/spc/util/spcUtils';

const aeto = [
	[
		'root::CX_Region'
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::LE_ColourTemperature_2'
	],
	[
		'root::EB_MotionSensor_1'
	],
	[
		'root::HS_Construction',
		'root::HS_HousingSize',
		'root::LU_SolarUnitHeight'
	],
	[
		'root::HS_HousingHeight'
	],
	[
		'root::LE_LuminairePositionHeight_1',
		'root::LE_LightDistribution_1',
	],
	[
		'root::LE_LuminairePositionHeight_2',
		'root::LE_LightDistribution_2'
	],
	[
		'root::LE_LuminairePositionAngle_1',
		'root::LE_LuminairePositionAngle_2',
		'root::LE_LuminairePositionHeightSU_1',
		'root::LE_LuminairePositionHeightSU_2',
		'root::LU_SolarUnit'
	]
];

const olivio = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_Accessories_1'
	],
	[
		'root::EB_Control_1',
		'root::EB_ConstantLumenTechnology_1',
		'root::EB_Zhaga_1',
		'root::EB_ElectricalProtectionClass_1',
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];

const aira = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
		'root::LE_OpticalVersion_1'
	],
	[
		'root::HS_HousingSize',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const alpha = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const anatar = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const arca = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const astro = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_OpticalVersion_1',
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const avanza = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::LE_OpticalVersion_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const axeo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const aya = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const beta = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const discera = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const elo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1'
	],
	[
		'root::LE_LightDistribution_1',
	],
	[
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const inula = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const jessica = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const lanova = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const lif = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ColourTemperature_1',
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
		'root::LE_LightDistribution_1'
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const lifPath = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize'
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_ReflectorColour_1',
		'root::LE_LightDistribution_1'
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const lukida = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const mistella = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const rondero = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const saturn = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
		'root::LE_ReflectorColour_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const sombreo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const tal = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const tessia = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const trigo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_OpticalVersion_1',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const tritec = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const valetta = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];
const yloo = [
	[
		'root::CX_Region'
	],
	[
		'root::HS_HousingSize',
	],
	[
		'root::HS_CircularBaseProfile',
	],
	[
		'root::LE_LightEngineModuleSize_1'
	],
	[
		'root::LE_LightDistribution_1',
		'root::LE_ColourTemperature_1',
	],
	[
		'root::Heads::Head::Type::Luminaire::LightEngine::LE_DimmingLevel',
	]
];

const wizardAttributeRelations = {

	LineComposition: [
		[
			'shared::Context::CX_Region',
			'shared::Context::CX_Usage',
			'shared::ProductType::HS_HousingType',
		],
		[
			'root::Poles::Pole::SpecialLine::HS_Construction',
		],
		[
			'shared::Context::LU_Filter_LightEmission_Uplight',
			'shared::Context::LU_Filter_LightEmission_CA',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightDistribution',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ColourTemperature',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_ReflectorColour',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_OpticalVersion',
			'root::Heads::Head:Type::Luminaire::LightEngine::LE_LightEngineModuleSize',
		],
		[
			'root::Heads::Head::Housing::HS_HousingConnection'
		],
		[
			'root::Poles::Pole::Basic::HS_Height',
			'root::Poles::Pole::Basic::HS_Base',
			'root::Poles::Pole::Basic::HS_NumberPoleDoors',
			'root::Heads::Head::ColourCoatingBase::HS_HousingColour',
			'root::Heads::Head::ColourCoatingBase::HS_HousingCoating',
		],
		[
			'root::Heads::Head::EBlock::EB_Control',
			'root::Heads::Head::EBlock::EB_ElectricalProtectionClass',
			'root::Zhaga::HS_HousingZhaga',
			'root::Heads::Head::EBlock::EB_ConstantLumenTechnology',
		],
		[
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_Uplight',
			'root::Heads::Head::Type::Luminaire::LightEngine::LE_LightEmission_CA'
		]
	],

	AetoExtern: aeto,

	OlivioExtern: olivio,
	OlivioUniversalExtern: olivio,
	OlivioBollardExtern: olivio,

	AiraPoleTopExtern: aira,
	AiraPendantExtern: aira,
	AiraCatenaryExtern: aira,

	AlphaExtern: alpha,

	AnatarExtern: anatar,

	ArcaExtern: arca,

	AstroExtern: astro,

	AvanzaExtern: avanza,

	AyaPoleTopExtern: aya,
	AyaPendantExtern: aya,
	AyaCatenaryExtern: aya,

	AxeoExtern: axeo,

	BetaPoleTopExtern: beta,
	BetaPendantExtern: beta,

	DisceraExtern: discera,

	EloPoleTopExtern: elo,
	EloBollardExtern: elo,
	EloColumnExtern: elo,
	EloWallSurfaceExtern: elo,

	InulaBollardExtern: inula,
	InulaColumnExtern: inula,

	JessicaExtern: jessica,

	LanovaPoleTopExtern: lanova,
	LanovaCatenaryExtern: lanova,

	LifTopElementExtern: lif,
	LifPathwayModuleExtern: lifPath,
	LifFacadeModule: lif,
	LifTwinspotModule: lif,

	LukidaExtern: lukida,

	MistellaExtern: mistella,

	RonderoExtern: rondero,

	SaturnPoleTopExtern: saturn,
	SaturnBollard: saturn,

	SombreoPoleLateralExtern: sombreo,
	SombreoCatenaryExtern: sombreo,

	TalExtern: tal,

	TessiaExtern: tessia,

	TrigoExtern: trigo,

	TritecReplacementKitsExtern: tritec,

	ValettaExtern: valetta,

	YlooPoleTopExtern: yloo,
	YlooPoleLateralExtern: yloo,
	YlooPendantExtern: yloo,
	YlooCatenaryExtern: yloo,

};

function arrayToWizardAttributeRelations(array) {
	return array.map(a => ({
		attributes: a.map(attributeKeyToId)
	}));
}

export function getWizardAttributeRelations(deploymentName) {
	if (wizardAttributeRelations.hasOwnProperty(deploymentName)) {
		return arrayToWizardAttributeRelations(wizardAttributeRelations[deploymentName]);
	} else {
		return null;
	}
}
